module.exports = __webpack_public_path__ + "static/CRMSAP Integration-a926c1d621f85071cbc836e5e55ca8da.svg";